export default {
	section_banner: {
		title: {
			one: '安全で楽しい方法',
		},
		main_title: {
			one: 'オンライン送金',
		},
		paragraph: {
			one: '世界中のほぼどこからでも家族や友人に簡単に送金できる簡単な方法です。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	qr_pay: {
		label: '転送の最適化',
		title: {
			one: '最大限に活用する',
			two: 'すべての転送',
		},
		paragraph:
			'JPWorldPayでは、すべての送金がスピード、セキュリティ、利便性を最適化しています。国内送金でも海外送金でも、低料金、リアルタイムの追跡、そして完全な透明性を享受できます。',
		white_box_1st: {
			heading: '双方向メッセージ',
			paragraph:
				'メッセージを交換して、友達間で支払いが正しく行われたかどうかを確認します。',
		},
		white_box_2nd: {
			heading: '無料オプション',
			paragraph:
				'JPWorldPayポイントカードを使用して、オンラインで残高を確認したり、海外に送金したりできます。',
		},
		white_box_3rd: {
			heading: 'クイックアクセス',
			paragraph:
				'暗号通貨を送金すると、受取人は遅滞なくお金を受け取ることができます。',
		},
	},
	round_monitor: {
		label: '暗号化技術',
		title: {
			one: '一年中',
			two: '監視',
		},
		paragraph:
			'JPWorldPayは、高度な暗号化技術を活用し、あらゆる取引の安全性を最優先に考えています。送金の安全性を確保し、安心して送金・受金いただけるよう、万全の体制で取り組んでいます。お客様の機密情報はあらゆる段階で保護され、新たな脅威から身を守るため、システムを継続的に更新しています。',
		cta_buttons: {
			one: '始めましょう',
		},
	},
	question_trade: {
		label: '送金',
		title: {
			one: '移行',
			two: '世界中',
		},
		paragraph: {
			one: 'JPWorldPayを使えば、世界中のどこへでも送金できます。世界中の友人や家族にオンラインで送金できます。個人でもビジネスでも、高速で信頼性が高く、使いやすいサービスです。低手数料で、送金のリアルタイム追跡もご利用いただけます。',
			two: '高度なセキュリティ機能に支えられた、安心の即時送信。24時間365日アクセスとサポートで、接続とコントロールを維持できます。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	ziga_sec: {
		label: 'JPWorldPay トランザクション',
		title: {
			one: '0 ジガトランザクション',
			two: '手数料',
		},
		paragraph:
			'他の銀行にリンクされたウォレットから出金する場合、JPWorldPayの残高から送金すれば出金手数料はかかりません。これにより、送金コストと利便性が向上し、不要な手数料を節約しながらスムーズな取引体験をお楽しみいただけます。さらに、JPWorldPayは迅速な処理時間を保証するため、資金はすぐに届きます。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
